module.exports = __webpack_public_path__ + "static/media/4전쟁-할아버지의감나무.9380eee4.mp3";